import React, { useEffect, useState } from 'react';
import { ReactSortable } from 'react-sortablejs';
import ManageSprint from './ManageSprint';
import BasicDelete from 'components/molecules/Modal/Delete/BasicDelete';
import { notifier } from 'components/Toaster';

function SprintList({ sprintData = [], mutate, onEdit, editingSprintId }) {
  const [list, setList] = useState([]);

  const actionsConfig = {
    open: false,
    data: {},
    Header: null,
    Body: null,
    isDeleteOperation: false,
  };
  const [actions, setActions] = useState({ ...actionsConfig });

  useEffect(() => {
    setList(sprintData || []);
  }, [sprintData]);

  const handleSort = () => {
    const payload = list.map((item, index) => ({
      id: item._id,
      sortPosition: index + 1,
    }));

    mutate(
      {
        type: 'REORDER',
        data: payload,
      },
      {
        onSuccess: (data) => {
          let message = data?.data?.data?.message;
          notifier.success(message);
        },
        onError: (err) => {
          let message = err?.response?.data?.message;
          notifier.err(message);
        },
      }
    );
  };

  const handleUpdate = (data) => {
    mutate({
      type: 'UPDATE',
      sprintId: data.sprintId,
      title: data.title,
      content: data.content,
      contentType: data.contentType,
    });
  };

  function handleDelete(sprint, index) {
    setActions({
      open: true,
      data: { sprintId: sprint._id },
      Header: 'Delete Sprint',
      Body: `Are you sure you want to delete "${
        sprint?.title ? sprint.title : `Sprint ${index + 1}`
      }"?`,
      isDeleteOperation: true,
    });
  }

  const handleDeleteConfirm = () => {
    mutate(
      {
        type: 'DELETE',
        sprintId: actions.data.sprintId,
      },
      {
        onSuccess: (data) => {
          let message = data?.data?.data?.message;
          notifier.success(message);
        },
        onError: (err) => {
          let message = err?.response?.data?.message;
          notifier.err(message);
        },
      }
    );
    setActions({ ...actionsConfig });
  };

  if (!list.length) {
    return (
      <div className="col-12 mt-4">
        <p>No sprint content available.</p>
      </div>
    );
  }

  return (
    <>
      <BasicDelete
        open={actions.open}
        closeModal={() => setActions({ ...actionsConfig })}
        Header={actions.Header}
        Body={actions.Body}
        handleConfirmation={handleDeleteConfirm}
      />
      <div className="col-12 mt-4">
        <h3 className="prime-head boldtitle mb-3">Sprint List</h3>

        <ReactSortable list={list} setList={setList} handle=".sprintGrabHandle" onSort={handleSort}>
          {list.map((sprint, index) => (
            <div className="row mt-3" key={sprint._id}>
              <div className="col-12">
                <div className="saved lessonWrap--border p-3 d-flex justify-content-between align-items-center">
                  <div className="sprintGrabHandle cursor-move">⠿</div>
                  <ManageSprint
                    sprint={sprint}
                    index={index}
                    handleSave={handleUpdate}
                    handleDelete={() => handleDelete(sprint, index)}
                    onEdit={onEdit}
                    isEditing={editingSprintId === sprint._id}
                  />
                </div>
              </div>
            </div>
          ))}
        </ReactSortable>
      </div>
    </>
  );
}

export default SprintList;
